export default {
    fund: [{
            "title": "某股权投资基金拟投资一家医药公司，在审阅其财务报表时，重点关注的内容不包括（　　）。",
            "question": "A．收入确认原则变得更为激进\nB．经营性现金流持续为负\nC．商誉计提较大金额减值\nD．参股公司的应收账款情况改善",
            "answer": "D",
            "explain": "财务尽职调查重点关注目标公司的历史财务业绩情况，并对企业未来财务状况进行合理预测。财务尽职调查团队应收集目标公司相关的财务报告及相关支持材料，了解其会计政策及相关会计假设，进行财务比率分析，重点考察企业的现金流、盈利及资产事项。财务尽职调查主要包括：会计政策与会计估计、财务报告及相关财务资料。"
        },
        {
            "title": "关于股权投资司基金直接投资业务中的“跟投”，以下表述正确的是（　　）。",
            "question": "A．股权投资母基金跟着所投资的基金直接投资项目\nB．创业企业的创业者跟着母基金直接投资项目\nC．股权投资母基金的投资者跟着母基金直接投资项目\nD．股权投资母基金所投资的基金跟着母基金直接投资项目",
            "answer": "A",
            "explain": "直接投资，是指母基金直接对非公开发行和交易的企业股权进行投资。在实际操作中，母基金通常和其所投资的股权投资基金联合投资，母基金往往扮演跟投角色，由股权投资基金来管理这项投资。"
        },
        {
            "title": "关于创业投资基金的运作，说法正确的是（　　）。",
            "questions": "I．投资对象包括早期、中期、后期各个发展阶段的未上市成长性企业<br>II．投资方式以控股性投资为主<br>III．经常用少量的自有资金结合大规模的外部资金来投资目标企业<br>IV．收益主要来源于所投资企业的股权增值",
            "question": "A．I、II\nB．I、IV\nC．II、III\nD．I、II、IV",
            "answer": "B",
            "explain": "创业投资基金的运作特点之一为：从杠杆应用看，一般不借助杠杆，以基金的自有资金进行投资。创业投资是指向处于创建或重建过程中的未上市成长性创业企业进行股权投资，以期所投资创业企业发育成熟或相对成熟后，主要通过股权转让获取资本增值收益的投资方式。"
        },
        {
            "title": "关于锁定期的表述错误的是（　　）。",
            "question": "A．自愿锁定是指在强制锁定的基础上，为了提升投资者信心，公司的实际控制人、高管、董事、监事、控股股东等自愿承诺在一定时间内不对外转让其持有的上市公司的股份\nB．锁定期分为强制锁定和自愿锁定两种\nC．强制锁定是根据法律法规或公司章程规定的关于股份锁定的规则\nD．锁定期的设置，通常是为了保护中小投资者的利益，防止“内部人”利用信息优势获得不当利益",
            "answer": "C",
            "explain": "锁定期（限售期）的设置，通常是为了保护中小投资者的利益，防止公司实际控制人、控股股东、董事、监事、高管等“内部人”利用信息优势获得不当利益，或者利用资本市场实现快速套现。锁定期分为强制锁定和自愿锁定两种，强制锁定是指法律法规或交易所规则规定的关于股份锁定的规则。"
        },
        {
            "title": "股权投资基金将其在被投资企业中的股权以协议转让等形式变现，从而退出投资，然后根据约定将退出所得分配给（　　）。",
            "question": "A．托管机构\nB．基金管理人\nC．基金的投资者和管理人\nD．基金投资者",
            "answer": "C",
            "explain": "股权投资基金的市场参与者主要包括投资者、管理人和第三方服务机构，就收益分配而言，则主要在投资者与管理人之间进行。"
        },
        {
            "title": "在基金风险揭示环节，属于股权投资基金特殊风险的有（　　）。",
            "questions": "I．基金未托管所涉风险<br>II．基金委托募集所涉风险<br>III．基金运营风险<br>IV．基金合同与中国证券投资基金业协会合同指引不一致所涉风险",
            "question": "A．I、III、IV\nB．I、II、III\nC．I、II、IV\nD．II、III、IV",
            "answer": "C",
            "explain": ""
        }, {
            "title": "股权投资基金在与目标企业签订投资协议时，适用于股权投资基金对特定重大事项行使一票否决权的条款是（　　）。",
            "question": "A．回购条款\nB．保密条款\nC．保护性条款\nD．反稀释条款",
            "answer": "C",
            "explain": "保护性条款是指股权投资基金为保护自身利益而设置的要求目标公司在执行某些可能损害投资者利益或对投资者利益有重大影响的行为时，需要取得投资者同意的条款。保护性条款针对的通常是涉及投资者经济利益或公司控制权的重要事项。"
        },
        {
            "title": "A创业投资基金持有G科技公司25%股权，其余75%由创始人团队持有。现创始人拟向投资人B股权投资基金出售其持有股权的5%，如果A行使随售权，则下列说法正确的是（　　）。",
            "question": "A．基金可以同样条件向B基金出售它持有的1.25%股权\nB．A基金可以同样条件优先于创始人团队，向B基金出售它持有的5%股权\nC．A基金可以同样条件优先于创始人团队，向B基金出售它持有的1.25%股权\nD．A基金可以同样条件向B基金出售它持有的5%股权",
            "answer": "A",
            "explain": "随售权又称共同出售权，是指目标公司的其他股东对外出售股权时，股权投资基金有权以其持股比例为基础，以同等条件参与该出售交易。5%x25%=1.25%。"
        },
        {
            "title": "关于保密条款，通常不属于具体约定事项的是（　　）。",
            "question": "A．保密信息的内容\nB．保密地域\nC．违约责任\nD．保密期限",
            "answer": "B",
            "explain": "通常，保密条款应列明保密信息的具体内容、保密期限及违约责任。"
        },
        {
            "title": "某合伙型基金A于2008年1月1日募集完成并设立，认缴规模3亿元人民币，全体合伙人自设立日起每年1月1日缴款1亿元，连续3年缴清全部认缴额。从2012年1月1日起，基金A每年将2亿元现金用于分配，连续3年，至2014年1月1日分配后完成清算。根据合伙协议约定，基金A按照瀑布式分配收益，即在全体合伙人回收全部本金并就其每笔出资达到单利8%年回报后，基金管理人行使追赶机制并可最多提取20%的净投资收益作为业绩报酬。2013年6月30日基金的已分配收益倍数为（　　）。",
            "question": "A．1.33\nB．缺少条件无法计算\nC．2\nD．0.67",
            "answer": "A",
            "explain": "已分配收益倍数是指截至某一特定时点，投资者已从基金获得的分配金额总和与投资者已向基金缴款金额总和的比率，体现了投资者现金的回收情况。2013年6月30日投资者已从基金获得的分配金额为4亿，投资者已向基金缴款总和为3亿。"
        },
        {
            "title": "按《企业所得税法实施条例》规定，创业投资企业采取股权投资方式投资于未上市的中小高新技术企业2年以上的，可以按照其投资额的（　　）在股权持有满2年的当年抵扣该创业投资企业的应纳税所得额。",
            "question": "A．0.6\nB．0.2\nC．0.4\nD．0.7",
            "answer": "D",
            "explain": "按《企业所得税法实施条例》规定，创业投资企业采取股权投资方式投资于未上市的中小高新技术企业2年以上的，可以按照其投资额的70%在股权持有满2年的当年抵扣该创业投资企业的应纳税所得额。"
        },
        {
            "title": "关于项目退出意义的表述，错误的是（　　）。",
            "question": "A．通过股东投资退出实现的收益可以衡量资本增值，有效的对投资活动进行价值发现、核算和评价\nB．只有建立健全、完善的项目退出机制，才能确保股权投资基金项目的顺利退出，保证基金持续流动性，实现基金预期目标\nC．股权投资基金通过投资目标企业，控制企业的经营和管理权，进而实现投资收益，控制风险\nD．当无法获取预期收益甚至存在亏损的可能性时，及时进行项目退出可适度规避投资风险",
            "answer": "C",
            "explain": "通过股东投资退出实现的收益可以衡量资本增值，有效的对投资活动进行价值发现、核算和评价。当无法获取预期收益甚至存在亏损的可能性时，及时进行项目退出可适度规避投资风险，只有建立健全、完善的项目退出机制，才能确保股权投资基金项目的顺利退出，保证基金持续流动性，实现基金预期目标。"
        }, {
            "title": "关于股权投资基金对目标公司开展尽职调查，以下表述错误的是（　　）。",
            "question": "A．尽职调查的作用主要包括风险发现、价值发现及投资决策辅助\nB．尽职调查的目的是尽可能全面地获取目标公司的真实信息\nC．尽职调查的内容主要包括法律、业务与财务三部分\nD．尽职调查是基金管理人的核心竞争力体现，主要由内部人员完成",
            "answer": "D",
            "explain": "股权投资机构尽职调查的目的，是尽可能全面地获取目标公司的真实信息。尽职调查的作用，一是价值发现，帮助投资方判断目标公司是否值得投资并获取项目估值所需信息；二是风险发现，通过获取目标公司的真实信息，识别和评估目标公司的主要风险，降低信息不对称可能带来的问题；三是投资决策辅助，依据尽职调查中发现的目标公司的特点和风险，帮助投资方在投资条款谈判、投资后管理重点内容、项目退出方式选择等方面做出决策。"
        },
        {
            "title": "关于基金销售机构，下列表述错误的是（　　）。",
            "question": "A．在中国证监会注册取得基金销售业务资格\nB．可自行募集股权投资基金\nC．从事股权投资基金募集的合格主体\nD．是中国证券投资基金业协会会员",
            "answer": "B",
            "explain": "可以从事股权投资基金募集行为的合格主体有以下两类：第一类是在基金业协会办理股权投资基金管理人登记的机构，其可以自行募集其设立的股权投资基金；第二类是在中国证监会注册取得基金销售业务资格并已成为基金业协会会员的机构（基金销售机构），也可以受股权投资基金管理人的委托募集股权投资基金。"
        },
        {
            "title": "关于中国证券投资基金业协会对基金服务机构可采取的自律措施，下列表述错误的是（　　）。",
            "question": "A．基金服务机构有一般违规情形的，中国证券投资基金业协会可以要求其限期改正\nB．基金服务机构严重违规的，中国证券投资基金业协会可视情节轻重对其采取公开谴责、暂停办理相关业务、撤销其基金服务机构登记或取消其会员资格等纪律处分\nC．基金服务机构严重违规的，中国证券投资基金业协会可对其主要负责人采取加入黑名单、公开谴责、暂停或取消基金从业资格等纪律处分\nD．一年之内基金服务机构有两次被要求限期改正的，中国证券投资基金业协会可以采取撤销其基金服务机构登记或取消其会员资格等纪律处分",
            "answer": "D",
            "explain": "服务机构有一般违规情形的，基金业协会可以要求服务机构限期改正。服务机构严重违规的，基金业协会可视情节轻重对服务机构采取公开谴责、暂停办理相关业务、撤销服务机构登记或取消会员资格等纪律处分；对服务机构主要负责人，基金业协会可采取加入黑名单、公开谴责等纪律处分。"
        },
        {
            "title": "关于股权投资基金管理人投资运作中的禁止行为，以下说法正确的是（　　）。",
            "question": "A．基金管理人可以通过境外机构或者境外系统下达投资交易指令\nB．基金管理人可以将自有固有财产或者他人财产混同于基金财产从事投资活动\nC．基金管理人可以外接未经监管机构或者自律组织认证的其他交易系统\nD．基金管理人不得将账户出借给第三方进行交易",
            "answer": "D",
            "explain": "股权投资基金管理人、股权投资基金托管人、股权投资基金销售机构及其他市场服务机构及其从业人员从事股权投资基金业务，不得有以下行为：(1)将其固有财产或者他人财产混同于基金财产从事投资活动；(2)不公平地对待其管理的不同基金财产；(3)利用基金财产或者职务之便进行利益输送；(4)侵占、挪用基金财产；(5)泄露因职务便利获取的未公开信息，利用该信息从事或明示、暗示他人从事相关的交易活动；(6)玩忽职守，不按照规定履行职责；(7)法律、行政法规和中国证监会规定禁止的其他行为。"
        },
        {
            "title": "股权投资基金尽职调查的核心内容为（　　）。",
            "question": "A．业务尽调\nB．法律尽调\nC．风险控制\nD．财务尽调",
            "answer": "A",
            "explain": "业务尽职调查是整个尽职调查工作的核心，目的是了解过去及现在企业创造价值的机制，以及这种机制未来的变化趋势。"
        },
        {
            "title": "在合伙型股权基金清算过程中，以下选项中（　　）不属于清算主体的职责。",
            "question": "A．编制基金资产负债表\nB．通知未了结债务的相应债权人\nC．编制清算报告\nD．修改基金存续期限",
            "answer": "D",
            "explain": "股权投资基金清算的主要程序如下：1.确定清算主体公司型股权投资基金的清算，应当成立清算组，并由清算组负责清算相关事宜。有限责任公司的清算组由股东组成，股份有限公司的清算组由董事或者股东大会确定的人员组成。逾期不成立清算组进行清算的，债权人可以申请人民法院指定有关人员组成清算组进行清算。"
        },
        {
            "title": "股权投资基金应当向合格投资者募集，单只股权投资基金的投资人数累计不得超过（　　）等法律规定的主体特定数量。",
            "questions": "I．《证券投资基金法》<br>II．《公司法》<br>III．《合伙企业法》",
            "question": "A．I、II、III\nB．I、III\nC．II、III\nD．I、II",
            "answer": "A",
            "explain": "股权投资基金应当向合格投资者募集，单只股权投资基金的投资人数累计不得超过《证券投资基金法》《公司法》《合伙企业法》等法律规定的主体特定数量。"
        }, {
            "title": "董事会席位条款的实质，是约定被投资企业的（　　）。",
            "question": "A．财产权分配\nB．控制权分配\nC．知情权分配\nD．收益权分配",
            "answer": "B",
            "explain": "董事会是公司治理的重要组成部分，董事会席位条款的实质是对被投资企业的控制权分配进行约定。"
        },
        {
            "title": "关于公司型基金，以下表述正确的是（　　）。",
            "questions": "I．公司型基金在很多国家相较其他组织形式的基金拥有更完整的组织结构和更规范的管理系统，因而可有效降低基金运作风险<br>II．公司型基金投资人作为股东承担有限责任，基金管理人承担无限责任<br>III．公司型基金投资人作为股东承担有限责任，是独立的企业法人<br>IV．公司型基金投资人可通过股东（大）会和董事会（执行董事）委任并监督基金管理人",
            "question": "A．II、III、IV\nB．I、III、IV\nC．II、IV\nD．I、II、IV",
            "answer": "B",
            "explain": ""
        },
        {
            "title": "股权投资基金尽职调查的目的是尽可能全面地获取目标公司的真实信息，它具有（　　）的作用。",
            "questions": "I．价值发现<br>II．风险清除<br>III．投资决策辅助<br>IV．风险发现",
            "question": "A．I、II、IV\nB．I、III、IV\nC．I、II、III、IV\nD．I、II、III",
            "answer": "B",
            "explain": "尽职调查的作用，一是价值发现，二是风险发现，三是投资决策辅助。"
        },
        {
            "title": "关于投资框架协议和投资协议，以下表述错误的是（　　）。",
            "question": "A．投资框架协议中的保密条款和排他性条款具有法律约束力，但其他内容不具有法律约束力\nB．估值调整条款、反摊薄条款及竞业禁止条款是投资协议和投资框架协议中的常见条款\nC．通常来说，投资协议的签署以投资框架协议的签署为前提\nD．投资框架协议的条款通常在投资协议中亦会涉及，条款的具体内容可能一致，也可能不一致",
            "answer": "C",
            "explain": "投资框架协议有时也被称为投资条款清单、投资备忘录或投资意向书，通常情况下，除保密条款和排他性条款外，投资框架协议的内容并不具有法律约束力，但它却包含了该次投融资的主要条款，这些主要条款通常会作为后续谈判及合作的基础，并最终成为正式投资协议的一部分。当然，根据后续尽职调查和商业谈判情况，投融资相关主体也可以对前述主要条款进行适当的调整。"
        },
        {
            "title": "关于股权投资基金的收益分配，以下表述正确的是（　　）。",
            "question": "A．收益分配主要在基金的投资者、管理人和第三方服务机构之间进行\nB．无论有无相关约定，基金管理人必须先让基金投资者实现门槛收益后才可以获得业绩报酬\nC．股权投资基金从事的是长期投资，自透明性好，收益较高，故基金管理人通常参与基金收益的分配\nD．基金的主要收益来源之一是投资企业分配的红利",
            "answer": "D",
            "explain": ""
        },
        {
            "title": "股权投资基金管理人向中国证券投资基金业协会申请管理人登记时，应根据要求聘请律师事务所出具法律意见书，所聘请的律师需对以下内容发表意见（　　）。",
            "questions": "I．登记申请材料、工商登记情况<br>II．股权结构、实际控制人、关联方及分支机构情况<br>III．风险管理制度和内部控制制度<br>IV．全体员工从业资质情况",
            "question": "A．II、III、IV\nB．I、II、IV\nC．I、II、III、IV\nD．I、II、III",
            "answer": "D",
            "explain": ""
        }, {
            "title": "在我国，影响股权投资基金具体组织形式的主要因素包括：（　　）。",
            "questions": "I．法律、监管<br>II．业务适应度<br>III．基金税负<br>IV．投资者税负",
            "question": "A．I、II、III\nB．I、II、III、IV\nC．I、III、IV\nD．II、III、IV",
            "answer": "B",
            "explain": ""
        },
        {
            "title": "关于对被投资企业的投后跟踪，以下表述正确的是（　　）。",
            "questions": "I．被投资企业是相对成熟的企业，应侧重关注其业绩指标，例如市场占有率、收入规模等<br>II．被投资企业是初创型企业，应关注其成长性，应尽快扭亏为盈<br>III．被投资企业更换审计机构，可能预示着问题即将发生，甚至已经发生，应重点关注<br>IV．被投资企业的财务比率指标不能一概而论，应综合考虑各个行业的特性",
            "question": "A．I、II\nB．II、III、IV\nC．I、II、IV\nD．I、III、IV",
            "answer": "C",
            "explain": "依据被投资企业自身经营情况，其经营指标监控侧重点也有所不同。对相对成熟的企业，应侧重关注其业绩指标，例如市场占有率、收入规模等。对初创型企业，应关注其成长性，应尽快扭亏为盈。被投资企业更换审计机构，并不预示问题即将发生。对被投资企业的财务比率指标不能一概而论。"
        },
        {
            "title": "关于并购基金，表述正确的是（　　）。",
            "question": "A．并购基金主要对企业新增的股权进行投资\nB．并购基金在收购中通常采用较高的杠杆率\nC．并购基金的投资收益主要来源于所投资企业的价值创造\nD． 战略投资者往往支付比并购基金更低的收购价格",
            "answer": "B",
            "explain": "并购基金通过购买股权的形式对企业的存量股权进行投资，并不为企业提供任何资金，只是一种所有权转移的投资方式，获得资金的是出让企业股权的股东。放“并购基金主要对企业新增的股权进行投资”错误。并购基金作为财务投资者，在收购中不会产生协同效应。与之相对应，战略投资者往往能够从收购中获得协同效应。从这个角度看，战略投资者往往支付比并购基金更高的收购价格。"
        },
        {
            "title": "以下属于合伙型股权投资基金合同中的必备条款是（　　）。",
            "questions": "I．基金管理费的收取方式<br>II．基金的利润分配及亏损分担方式<br>III．基金的关键人条款<br>IV．合伙期限，包括基金投资期和退出期等",
            "question": "A．I、II、IV\nB．I、III、IV\nC．I、II、III\nD．II、III、IV",
            "answer": "A",
            "explain": ""
        },
        {
            "title": "关于政府引导基金的描述正确的是（　　）。",
            "question": "A．政府引导基金通常投资于基础设施基金\nB．政府引导基金通常投资于并购基金\nC．政府引导基金通常投资于定向增发投资基金\nD． 政府引导基金通常投资于创业投资基金",
            "answer": "D",
            "explain": "政府引导基金是一类特殊类型的母基金，主要是通过投资于创业投资基金，达到支持创业投资基金发展的目的。"
        },
        {
            "title": "某公司型股权投资基金，所投资企业完成首次公开发行上市，该基金通过二级市场退出取得的收入需要计缴（　　）。",
            "questions": "I．营业税<br>II．增值税<br>III．企业所得税<br>IV．印花税",
            "question": "A．II、III、IV\nB．I、III\nC．II、III\nD．I、II",
            "answer": "A",
            "explain": ""
        },
        {
            "title": "投资机构一般通过参加被投资企业的公司治理获取被投资企业的信息，一般情况下，投资机构不参加被投资企业的（　　）。",
            "question": "A．股东大会（股东会）\nB．经营层\nC．监事会\nD． 董事会",
            "answer": "B",
            "explain": "为了降低投资后的委托代理风险，投资机构通常会直接参与被投资企业股东大会、董事会和监事会，以提出议案或参与表决的方式，对被投资企业的经营管理实施监控。"
        }, {
            "title": "2017年底，公司型股权投资基金A投资一家环保类企业3000万元，2018年基金A从该企业取得600万元的分红收入，则其需要对此部分收入（　　）。",
            "question": "A．无需计缴增值税，企业所得税按规定免税\nB．仅计缴企业所得税\nC．计缴增值税和企业所得税\nD．仅计缴增值税",
            "answer": "A",
            "explain": ""
        },
        {
            "title": "关于未上市公司股权转让，以下表述正确的是（　　）。",
            "questions": "I．公司章程中可以规定，有限责任公司的股权在外部转让时须经其他股东过半数同意<br>II．公司章程中可以规定，有限责任公司的股东内部之间转让股权须经其他股东过半数同意<br>III．公司章程中不能规定，有限责任公司的股东内部之间转让股权须经其他股东过半数同意<br>IV．公司章程中不能规定，有限责任公司的外部转让须经其他股东过半数同意",
            "question": "A．I、III\nB．I、IV\nC．III、IV\nD．II、III",
            "answer": "A",
            "explain": ""
        },
        {
            "title": "根据已有条件，以下不能确定为股权投资基金合格投资者的是（　　）。",
            "question": "A．持有价值500万元房产的无收入大学在校学生\nB．社会保障基金\nC．持有市值350万元股票的某工厂流水线员工\nD．依法设立的上海某慈善基金",
            "answer": "A",
            "explain": ""
        },
        {
            "title": "某合伙型股权投资基金认缴总额为20亿元，其中基金管理人A作为普通合伙人认缴5亿元，所有投资者已一次性缴纳完毕，该基金采用瀑布式的收益分配体系，按照基金整体进行收益分配，分配收益时先返还投资者本金，超额收益部分20%作为业绩报酬，80%分配至全体投资者，该基金未设置门槛收益。基金完成所有项目退出后，共计可分配金额为40亿元。在不考虑基金费用的情况下，基金管理人A总共获得资金合计为（　　）。",
            "question": "A．9亿元\nB．20亿元\nC．16亿元\nD．13亿元",
            "answer": "D",
            "explain": ""
        },
        {
            "title": "A公司在融资前的股份数量为4000万股，均为控股股东持有。某股权投资基金于2015年12月31日向A公司投资2000万元人民币，获得股份数量为1000万股。投资协议有如下约定：<br>I．投资金额的50%在协议签署后90日内划拨，剩余50%在2016年12月31日或产品B获得行政审批就早日划拨<br>II．如果A公司2018年净利润不满足3000万元，则控股股东或其关联方需要向该股权投资基金支付现金补偿，补偿金额为投资金额x(3000万-实际净利润)/3000万<br>III．如果A公司在2019年12月31日前未完成上市，则控股股东或其关联方需要回购该股权投资基金持有的股份，回购价款总额=投资总额x(1+8%x投资年限)-回购日之前股权投资基金已获得的红利-回购日之前股权投资基金已获得的业绩补偿(如有)<br>IV．如果关键管理人员甲离职，则控股股东或其关联方需要无条件转让给该股权投资基金5%的股份\nV.投资协议签署了反摊薄条款，约定在降价融资时，控股股东将以加权平均方式补偿给该股权投资基金。若A公司的发展状况未达预期，2018年度的净利润为2000万元，已按约定进行了业绩补偿；截至2019年12月31日，A公司未能完成上市，该公司的控股股东或其关联方回购股份需要付出的对价最接近（　　）万元。",
            "question": "A．2640\nB．1813\nC．1973",
            "answer": "C",
            "explain": ""
        },
        {
            "title": "关于中国证券投资基金业协会，表述错误的是（　　）。",
            "question": "A．其最高权力机构为理事会\nB．对会员间的调节仅是民间性的，如果对调节不满意，纠纷方有权提起诉讼或仲裁\nC．有权对违反自律规则和中国证券投资基金业协会章程的行为给予纪律处分\nD．负责开展投资者教育活动及行业宣传",
            "answer": "A",
            "explain": "基金业协会的最高权利机构为会员代表大会。理事会是会员代表大会闭会期间的执行机构，在会员代表大会闭会期间领导本团体开展日常工作，对会员代表大会负责。"
        },
        {
            "title": "境内间接上市的主要方式不包括（　　）。",
            "question": "A．企业通过借壳上市的，一般上市公司的实际控制人将发生变化\nB．被投资企业可以通过申报IPO将企业股权转变为上市公司的股权\nC．基金可通过“现金+股权”的方式，实现部分退出\nD．企业可以通过资产重组或借壳上市等方式间接上市",
            "answer": "B",
            "explain": "境内间接上市的方式包括参与上市公司重大资产重组或借壳上市，IPO属于直接上市的方式。"
        }, {
            "title": "根据《私募投资基金监督管理暂行办法》的专业化经营原则，律师在出具法律意见书时需要对申请机构核查的内容包括（　　）。",
            "questions": "I．主营业务是否为股权投资基金管理业务<br>II．是否兼营可能与股权投资基金业务存在冲突的业务<br>III．是否兼营与“投资管理”的买方业务存在冲突的业务<br>IV．是否兼营其他非金融业务",
            "question": "A．I、II、III、IV\nB．I、II、IV\nC．II、III、IV\nD．I、II、III",
            "answer": "A",
            "explain": "为进一步落实专业化经营，基金管理人应按照如下要求进行运营：(1)基金管理人的主营业务应为私募基金管理业务，不得兼营与私募基金无关的业务；(2)基金管理人的名称和经营范围中应当包含“基金管理”“投资管理”“资产管理”“股权投资”“创业投资”等与基金投资管理相关的业务。"
        },
        {
            "title": "某合伙型股权投资基金规模2亿元，所有投资者均完成实缴。该基金采用瀑布式收益分配体系，按照基金整体分配收益，没有约定门槛收益，无追赶机制，如有超额收益按“二八模式”分成。基金存续期7年结束进入清算，所有项目完成退出，退出金额合计5亿元，期间所有税费合计2000万元。基金管理人可获得业绩报酬（　　）亿元。",
            "question": "A．0.6\nB．0.96\nC．0.56\nD．0.376",
            "answer": "C",
            "explain": "在瀑布式收益分配体系下，如果没有约定门槛收益又无追赶机制，则在返还投资人本金之后，从剩余的资产扣减相应的费用，按照“二八模式”进行分配。即基金收益或超额收益的20%作为业绩报酬分配至基金管理人，80%分配至基金投资者。项目退出金额5亿元，实缴规模2亿元，则返还投资者本金后剩余3亿元，扣除税费2000万元，剩余2.8亿元，则基金管理人可获得的业绩报酬为2.8亿x0.2=0.56亿元。"
        },
        {
            "title": "王律师在做某股权投资项目尽职调查时着重关注了目标公司与公司高管签订的劳动合同，检查其中的竞业禁止条款以及对应的补偿条款，并检查了目标公司历史上是否发生过主要管理人员离职后的劳动仲裁或纠纷的情况。这里体现的法律尽职调查主要关注点为（　　）。",
            "question": "A．历史沿革\nB．潜在诉讼\nC．高级管理人员\nD．重大合同",
            "answer": "C",
            "explain": "法律尽职调查中对高级管理人员的调查，应重点关注的问题是高级管理人员是否与企业签订了应有的劳动合同，是否存在劳动仲裁或纠纷情况。股权投资中可能出现的不利后果是，主要管理人员离职后开展与目标公司相竞争的业务或到竞争对手处任职。律师应关注目标公司与主要高管的劳动合同中是否包括竞业禁止条款以及对应的补偿条款。故本题“体现的法律尽职调查主要关注点为高级管理人员”。"
        },
        {
            "title": "重置成本法的计算公式为（　　）。",
            "question": "A．待评估资产价值=重置全价-综合贬值\nB．待评估资产价值=重置全价-总负债\nC．待评估资产价值=重置全价+综合贬值\nD．待评估资产价值=重置全价+总负债",
            "answer": "A",
            "explain": "重置成本法是用待评估资产的完全重置成本(重置全价)减去其各种贬值后的差额作为该项目资产价值的评估方法。用公式表示为：待评估资产价值=重置全价-综合贬值或待评估资产价值=重置全价x综合成新率"
        },
        {
            "title": "合格投资者必须具备的要素包括（　　）。",
            "questions": "I．具备风险识别能力<br>II．达到规定的资产规模或收入水平<br>III．具备风险承担能力<br>IV．具备专业的投资能力",
            "question": "A．I、II、III、IV\nB．I、III、IV\nC．III、IV\nD．I、II、III",
            "answer": "D",
            "explain": "具备风险识别能力和承担能力、投资额不低于规定限额、资产规模或者收入水平达到一定要求，是合格投资者必备的三个要素。"
        },
        {
            "title": "关于折现现金流估值法，表述错误的是（　　）。",
            "question": "A．红利折现模型不适用于红利发放政策不稳定的目标公司\nB．企业自由现金流折现模型得到的是企业价值，可以通过价值等式推出股权价值\nC．股权自由现金流是可以自由分配给股权拥有者的最低现金流\nD．企业自由现金流量指公司在保持正常运营的情况下，可以向出资人(股东和债权人)进行自由分配的现金流",
            "answer": "C",
            "explain": "股权自由现金流是可以自由分配给股权拥有者的最大现金流。"
        }, {
            "title": "股权投资基金宣传推荐资料章载过往业绩的，一般应遵循（　　）原则。",
            "questions": "I．基金合同已经生效一段时间，如6个月以上<br>II．无需声明“股权投资基金的过往业绩并不预示其未来表现”<br>III．应登载完整的业绩记录<br>IV．如基金存续期间较长，可登载近几年的完整、连续业绩，如近5年完整的业绩记录",
            "question": "A．II、III、IV\nB．I、II、III\nC．I、II、III、IV\nD．I、III、IV",
            "answer": "D",
            "explain": "股权投资基金宣传推介材料可以登载该股权投资基金、股权投资基金管理人管理的其他股权投资基金的过往业绩，股权投资基金宣传推介材料登载过往业绩的，一般应当遵循以下原则：(1)基金合同已生效一段时间，如6个月以上；(2)应登载完整的业绩记录；(3)如基金存续期间较长，可登载近几年的完整、连续业绩，如近5年完整的业绩记录。"
        },
        {
            "title": "设立时不需要涉及工商登记程序的基金类型的是（　　）。",
            "question": "A．有限责任公司型基金\nB．股份有限公司型基金\nC．信托(契约)型基金\nD． 合伙型基金",
            "answer": "C",
            "explain": "不同于公司型及合伙型股权投资基金，信托(契约)型股权投资基金无须在工商行政管理机关办理工商登记手续。基金管理人可以自行办理股权投资基金的权益登记(份额登记)事项，也可委托基金服务机构代为办理，但基金管理人应当承担的登记职责不因委托而免除。"
        },
        {
            "title": "关于清算退出表述错误的是（　　）。",
            "question": "A．破产清算是指公司不能清偿到期债务，并且资产不足以清偿全部债务或者明显缺乏清偿能力时，公司被法院宣告破产，并由法院组织对公司进行清算\nB．有限责任公司的清算组由董事会或股东大会确定的人员或由股东组成\nC．公司经营管理发生严重困难，继续存续会使股东利益受到重大损失，通过其他途径不能解决时，持有公司全部股东表决权百分之十的股东可以向人民法院申请解散并获法院支持的，应当进行解散清算\nD． 清算退出包括解散清算和破产清算",
            "answer": "B",
            "explain": "公司清算的，有限责任公司的清算组由股东组成，股份有限公司的清算组由董事或股东大会确定的人员组成。"
        },
        {
            "title": "使用折现现金流估值法对企业进行估值时，可以直接计算得到股权价值的模型（　　）。",
            "questions": "I．红利折现模型<br>II．股权自由现金流折现模型<br>III．企业自由现金流折现模型<br>IV．企业净资产折现模型",
            "question": "A．II、III\nB．I、IV\nC．I、II\nD．II",
            "answer": "C",
            "explain": "使用折现现金流估值法对企业进行估值时，评估所得的价值可以是股权价值，可以是企业价值，其中可以直接计算得到股权价值的模型是红利折现模型。"
        },
        {
            "title": "中国证券投资基金业协会将已登记的基金管理人列入异常机构并对外公示的情形有（　　）。",
            "questions": "I．甲基金管理人没有履行重大事项报送更新义务累计达到两次<br>II．乙基金管理人没有按要求提交经审计的年度财务报告<br>III．丙基金管理人没有按时履行季度、年度信息报送更新义务<br>IV．丁基金管理人被列入信息公示系统严重违法失信企业公示名单",
            "question": "A．II、III、IV\nB．I、II、IV\nC．I、II、III、IV\nD．I、II、III",
            "answer": "B",
            "explain": "已登记的基金管理人存在如下情况之一的，基金业协会将其列入异常机构名单，并通过私募基金管理人平台对外公示，一旦基金管理人作为异常机构公示，及时整改完毕，至少6个月内才能恢复正常机构公示状态：(1)基金管理人未按时履行季度、年度和重大事项信息报送更新义务"
        },
        {
            "title": "普通投资者主动要求购买与之风险承受能力不匹配的基金产品，下列表述错误的是（　　）。",
            "question": "A．基金募集机构对普通投资者资格进行审核，确认其不属于风险承受能力最低类别投资者\nB．基金募集机构以纸质或者电子文档的方式向投资者进行特别警示，告知该产品或服务风险高于投资者承受能力\nC．普通投资者还需要同时声明基金募集机构及其工作人员没有在基金销售过程中主动推荐该基金产品或服务的信息\nD． 基金募集机构履行特别警示义务以后，风险承受能力最低类别投资者可以购买高于其风险承受能力的基金产品",
            "answer": "D",
            "explain": "普通投资者要求购买与之风险承受能力不匹配的基金产品的，基金销售应遵循以下程序：普通投资者主动向基金募集机构提出申请，明确表示要求购买具体的高于其风险承受能力的基金产品，并同时声明，基金募集机构及其工作人员没有在基金销售过程中主动推介该基金产品或服务的信息；基金募集机构对普通投资者资格进行审核，确认其不属于风险承受能力最低类别投资者，也没有违反投资者准入规定；基金募集机构向普通投资者以纸质或电子文档的方式进行特别警示，告知该产品或服务风险高于投资者承受能力；基金募集机构履行特别警示义务后，风险承受能力最低类别投资者不可以购买高于其风险承受能力的基金产品。"
        }, {
            "title": "关于公司型股权投资基金的下列经营活动，无须向工商行政管理机关办理登记手续的是（　　）。",
            "question": "A．公司型股权投资基金增资、减资\nB．公司型股权投资基金收益分配影响注册资本\nC．股份有限公司型股权投资基金发起人以外的股东发生变更\nD．公司型股权投资基金的股东将持有股份进行内部转让",
            "answer": "C",
            "explain": "股份有限公司型股权投资基金除发起人以外的股东发生变更的，因为不影响法人财产权，所以无须向工商行政管理机关办理登记手续。"
        },
        {
            "title": "A公司在融资前的股份数量为4000万股，均为控股股东持有。某股权投资基金于2015年12月31日向A公司投资2000万元人民币，获得股份数量为1000万股。投资协议有如下约定：",
            "questions": "I．投资金额的50%在协议签署后90日内划拨，剩余50%在2016年12月31日或产品B获得行政审批就早日划拨<br>II．如果A公司2018年净利润不满足3000万元，则控股股东或其关联方需要向该股权投资基金支付现金补偿，补偿金额为投资金额x(3000万-实际净利润)/3000万<br>III．如果A公司在2019年12月31日前未完成上市，则控股股东或其关联方需要回购该股权投资基金持有的股份，回购价款总额=投资总额x(1+8%x投资年限)-回购日之前股权投资基金已获得的红利-回购日之前股权投资基金已获得的业绩补偿(如有)<br>IV．如果关键管理人员甲离职，则控股股东或其关联方需要无条件转让给该股权投资基金5%的股份\nV.投资协议签署了反摊薄条款，约定在降价融资时，控股股东将以加权平均方式补偿给该股权投资基金上述投资协议中属于估值调整条款中现金补偿类的是（　　）。",
            "question": "A．I、II、III\nB．II、III、IV\nC．II、III\nD．I、II、II、IV",
            "answer": "C",
            "explain": ""
        },
        {
            "title": "关于有限合伙企业设立人数的表述，以下表述正确的是（　　）。",
            "question": "A．有限合伙企业由2-100个合伙人设立\nB．有限合伙企业由1-50个合伙人设立\nC．有限合伙企业由1-100个合伙人设立\nD．有限合伙企业由2-50个合伙人设立",
            "answer": "D",
            "explain": "对于合伙型基金，除法律另有规定的特殊情形外，有限合伙企业应由2个以上50个以下合伙人设立，且有限合伙企业至少应当有一个普通合伙人。"
        },
        {
            "title": "我国现行的股权投资基金组织形式不包括（　　）。",
            "question": "A．合伙型\nB．有限责任公司型\nC．股份有限公司型\nD．封闭型",
            "answer": "D",
            "explain": "股权投资基金需要具备一定的组织形式，在我国，现行的股权投资基金组织形式主要分为公司型、合伙型和信托（契约）型。"
        },
        {
            "title": "监管机构对于股权投资基金管理人及其从业人员违法违规行为的主要监督处理方式包括（　　）。",
            "questions": "I． 中国证监会及其派出机构采取行政监管措施<br>II．中国证监会及其派出机构进行行政处罚<br>III．中国证监会将违法犯罪线索移送司法机关审查处理<br>IV．中国证监会对投资基金业协会采取自律管理措施",
            "question": "A．II、III、IV\nB．II、IV\nC．I、III、IV\nD．I、II、III",
            "answer": "D",
            "explain": ""
        },
        {
            "title": "关于股权投资基金的企业间接上市，以下表述错误的是（　　）。",
            "question": "A．将资产注入已上市公司可以实现间接上市\nB．参与上市公司重大资产重组，可能使得基金通过直接股权转让实现收益或持有上市公司的股份\nC．间接上市成功之后，股权投资基金的被投资企业的股份将转变成为上市公司的股份\nD．间接上市成功之后，基金应要求上市公司现金回购实现退出",
            "answer": "D",
            "explain": "所投资企业除了股票首次公开发行并上市外，还可以通过参与上市公司重大资产重组或借壳上市等方式间接上市，间接上市成功的，股权投资基金持有的被投资企业股份（股权）也可以转变成为相关上市公司的股份，通过公开市场转让实现退出。"
        },
        {
            "title": "关于股权投资基金运作，以下表述错误的是（　　）。",
            "question": "A．投资策略通常依据基金的投资目标及投资者对风险和期望收益的偏好来确定\nB．基金的投资范围、投资策略一般不会在基金合同中明确示例\nC．投资限定的确定，通常服务于保护投资者利益这一目标\nD．投资范围通常依据目标投资对象的行业、地域、发展阶段等属性来确定",
            "answer": "B",
            "explain": "通常情况下，基金的投资范围、投资策略和投资限制由基金管理人投资者共同商定，并在基金合同中明确列示。"
        },
        {
            "title": "当股权投资基金出现（　　）情况时，应当对基金进行所有者权益核算。",
            "question": "A．已投项目出现大额亏损\nB．签订大额负债合同\nC．吸收新的投资者\nD．已投项目的公允价值出现明显波动",
            "answer": "C",
            "explain": "当基金出现权益变动，包括新的投资者参与、老的投资者退出以及基金收益分配等情况时，应当进行所有者权益核算。"
        },
        {
            "title": "关于合伙型基金的架构及特点描述错误的是（　　）。",
            "question": "A．普通合伙人可自行担任基金管理人或者委托专业的基金管理机构担任基金管理人\nB．至少由1个普通合伙人和1个有限合伙人组成\nC．基金由基金管理人具体负责投资运作，有限合伙人可以参与投资决策\nD．普通合伙人对基金的债务承担无限连带责任，有限合伙人以其认缴的出资额为限对基金债务承担责任",
            "answer": "C",
            "explain": "普通合伙人可自行担任基金管理人或者委托专业的基金管理机构担任基金管理人。有限合伙人不参与投资决策。"
        },
        {
            "title": "关于股权投资基金“资产保管”的托管服务内容，以下表述错误的是（　　）。",
            "questions": "I．基金托管人无须将不同基金的资产严格隔离<br>II．基金财产的债权可以与托管人固有财产的债务相抵销<br>III．不同基金财产的债权债务可以相互抵销<br>IV．基金托管人必须将基金资产与其自有资产严格隔离\nV.基金托管人无须将不同基金的资产严格隔离",
            "question": "A．II、III、IV\nB．I、II、III\nC．III、IV、V\nD．II、III、V",
            "answer": "D",
            "explain": "基金托管人必须将基金资产与其自有资产严格隔离。"
        },
        {
            "title": "股权投资基金管理人违反法律、法规、规章的规定，监管机构可以对其采取行政处罚，关于行政处罚，以下表述正确的是（　　）。",
            "question": "A．行政处罚的对象包括股权投资基金管理人、托管人和销售机构，不包括股权投资基金估值核算机构\nB．对行政处罚不服的，既可以申请行政复议，也可以直接提起行政诉讼\nC．中国证监会可以进行行政处罚，其派出机构不能进行行政处罚\nD．中国证监会发现犯罪线索的，移送司法机关依照法律规定做出行政处罚",
            "answer": "B",
            "explain": ""
        },
        {
            "title": "某股权投资基金募集材料披露基金首轮交割日为2015年6月30日，最后交割日为2016年3月31日，该披露事项为基金的（　　）。",
            "question": "A．投资期限\nB．存续期限\nC．退出期限\nD．募集期限",
            "answer": "D",
            "explain": "题目中披露的为股权投资基金的募集期限。"
        },
        {
            "title": "关于投资后增值服务，以下表述错误的是（　　）。",
            "question": "A．为企业提供管理咨询服务，主要是指为被投资企业提供战略、组织、财务、人力资源市场营销等方面的咨询建议\nB．被投资企业往往倾向于选择那些在投资行业内具有广泛关系网络的投资机构，保证后续轮次的融资活动顺利进行\nC．后续再融资是指投资机构会利用自己在资本市场的关系网络，为被投资企业进行债权融资\nD．投资机构协助企业建立规范的现代财务管理体系，以“规范管理、风险控制和全面预算”为基本准则",
            "answer": "C",
            "explain": "后续再融资是指投资机构会利用自己在资本市场的关系网络，为被投资企业进行股权融资。"
        },
        {
            "title": "保护性条款的实施方向体现了该条款的独特性在于（　　）。",
            "question": "A．多数股东反对即可终结特定事项\nB．多数股东同意即可通过特定事项\nC．少数股东反对即可终结特定事项\nD．少数股东同意即可通过特定事项",
            "answer": "C",
            "explain": "保护性条款是指股权投资基金为保护自身利益而设置的要求目标公司在执行某些可能损害投资者利益或对投资者利益有重大影响的行为时，需取得投资者同意的条款。"
        },
        {
            "title": "公司自由现金流量归属于（　　）的现金流量。",
            "questions": "I．公司股东<br>II．公司管理层<br>III．公司债权人",
            "question": "A．I\nB．I、II、III\nC．I、III\nD．II、III",
            "answer": "C",
            "explain": "企业自由现金流是指公司在保持正常运营的情况下，可以向所有出资人（股东和债权人）进行自由分配的现金流。"
        },
        {
            "title": "在计算股权投资基金净内部收益率时，需从现金流中扣除的项目（　　）。",
            "questions": "I．支付给管理人的基金管理费<br>II．支付给托管人的基金托管费<br>III．支付给管理人的业绩报酬<br>IV．支付给投资人的门槛收益",
            "question": "A．II、III、IV\nB．I、II、III、IV\nC．I、II、III\nD．I、II、IV",
            "answer": "C",
            "explain": "净内部收益率是在毛内部收益率基础上考虑了基金费用和管理人业绩报酬对投资者现金流的影响。"
        },
        {
            "title": "股权投资基金募集过程中，下述行为正确的是（　　）。",
            "question": "A．通过微信、手机短信向不特定对象宣传推介\nB．要求投资者以书面形式承诺其符合合格投资者标准\nC．向投资者承诺投资本金有保障\nD． 通过讲座、报告会向不特定对象宣传推介",
            "answer": "B",
            "explain": "未经特定对象确定程序，不得向任何人宣传推介股权投资基金，确定流程要求如下：(1)采取问卷调查评估投资者的风险识别能力和风险承担能力；(2)投资者书面承诺其符合合格投资者标准。"
        },
        {
            "title": "下列企业更适用于成本法的是（　　）。",
            "question": "A．正常运营中的电子商务企业\nB．某商业零售企业\nC．某持续经营的机械制造企业\nD． 新设不到三个月、尚未开展具体经营的投资企业",
            "answer": "D",
            "explain": "成本法可用于对无市场价格的资产进行估值，处于正常运营中的电子商务企业、商业零售企业及机械制造企业用相对估值法或折现现金流估值法较为合理。"
        },
        {
            "title": "关于创业投资和杠杆收购区别，以下表述错误的是（　　）。",
            "question": "A．杠杆收购主要针对成熟企业\nB．天使投资属于组织创业投资范畴\nC．杠杆收购的企业通常资产性支出较低\nD． 创业投资通常采取参股性投资",
            "answer": "B",
            "explain": "天使投资是指除被投资企业职员及家庭关系成员和直系亲属以外的个人以其自有资金直接开展的创业投资活动，属于非组织化创业投资范畴。"
        },
        {
            "title": "我国私募股权投资基金行业自律规则包括（　　）。",
            "questions": "I．《私募投资基金管理人登记和基金备案办法（试行）》<br>II．《私募投资基金信息披露管理办法》<br>III．《私募投资基金管理人内部控制指引》<br>IV．《私募投资基金募集行为管理办法》",
            "question": "A．II、III、IV\nB．I、II、III、IV\nC．I\nD．I、II、IV",
            "answer": "B",
            "explain": "协会自律规则包括《私募投资基金管理人登记和基金备案办法（试行）》、《私募投资基金管理人内部控制指引》、《私募投资基金信息披露管理办法》、《私募投资基金募集行为管理办法》等。"
        },
        {
            "title": "当投资者风险承受能力与基金产品风险等级不匹配时，以下表述正确的是（　　）。",
            "question": "A．募集机构直接允许投资者购买与其风险承受能力不匹配的产品\nB．募集机构不需要确认投资者是否属于风险承受能力最低类别的投资者\nC．投资者不能购买与其风险承受能力不匹配的产品\nD． 投资者坚持购买与其风险承受能力不符的产品或者服务时，募集机构应该遵循特定程序进行特别风险警示",
            "answer": "D",
            "explain": "普通投资者要求购买与之风险承受能力不匹配的基金产品的，基金销售应遵循以下程序：普通投资者主动向基金募集机构提出申请，明确表示要求购买具体的、高于其风险承受能力的基金产品，并同时声明，基金募集机构及其工作人员没有在基金销售过程中主动推介该基金产品或服务的信息；基金募集机构对投资者资格进行审核，确认其不属于风险承受能力最低类别投资者，也没有违反投资者准入规定；基金募集机构向普通投资者以纸质或电子文档的方式进行特别警示，告知该产品或服务风险高于投资者承受能力；投资者坚持购买与其风险承受能力不符的产品或服务时，募集机构应遵循特定程序进行特别风险警示。"
        },
        {
            "title": "下列选项中，不属于公司型股权投资基金清算的原因的是（　　）。",
            "question": "A．依法被吊销营业执照、责令关闭或被撤销\nB．因公司合并或者分立需要解散\nC．公司章程规定的营业期限届满或者公司章程规定的其他解散事由出现\nD． 董事会决定解散",
            "answer": "D",
            "explain": "公司型股权投资基金清算的原因包括：依法被吊销营业执照、责令关闭或被撤销；因公司合并或分立需要解散；公司章程规定的营业期限届满或公司章程规定的其他解散事由出现。"
        }, {
            "title": "以下投资类型不符合我国当前法律和监管规则的是（　　）。",
            "question": "A．公募股权投资基金\nB．公募证券投资基金\nC．私募证券投资基金\nD． 私募股权投资基金",
            "answer": "A",
            "explain": "就募集方式而言，股权投资基金有公开募集和非公开募集两类，我国目前仅允许非公开募集股权投资基金。"
        },
        {
            "title": "股权投资基金的收益分配，主要在（　　）之间进行。",
            "question": "A．投资者与第三方服务机构\nB．投资者和托管人\nC．投资者与管理人\nD． 管理人和托管人",
            "answer": "C",
            "explain": "股权投资基金的收益分配主要在投资者与管理人之间进行。"
        },
        {
            "title": "在我国不能作为公司型股权投资基金的是（　　）。",
            "questions": "I．有限责任公司<br>II．股份有限公司<br>III．A股上市公司<br>IV．无限责任公司",
            "question": "A．I、II、III、IV\nB．III、IV\nC．II、III\nD．II、III、IV",
            "answer": "B",
            "explain": ""
        },
        {
            "title": "某股权投资基金投资了某医院管理公司X，双方签署了包含保密条款的投资协议，该基金可能违反保密义务的行为是（　　）。",
            "question": "A．在向基金投资者定期披露的基金报告中描述X项目投资金额及项目基本情况\nB．经X项目书面允许向媒体披露了其最新纳入托管的医院名称\nC．向基金审计师提供了X项目的年度财务报表\nD． 向基金现有投资组合中同行业项目高管介绍并咨询确认X项目扩张规划的合理性",
            "answer": "D",
            "explain": "保密条款是指除依法律或监管机构要求的信息披露外，投融资双方对在股权投资交易中知悉的对方商业秘密承担保密义务，未经对方书面同意，不得向第三方泄露。"
        },
        {
            "title": "关于投资后管理的表述，错误的是（　　）。",
            "question": "A．投资后管理是基金管理人积极参与被投资企业管理，对被投资企业实施项目监控，并提供各项增值服务等一系列活动\nB．投资后管理关系到投资项目退出方案的计划与实施\nC．投资后管理就是投资后的风险管理\nD． 在投资交割后直到项目退出之前都属于投资后管理的期间",
            "answer": "C",
            "explain": "投资后管理不同于项目管理，也不能简单地将其理解为投资后的风险管理。通常，投资后管理的主要内容可以分为两类，第一类为投资机构对被投资企业进行的项目跟踪与监控活动；第二类为投资机构为被投资企业提供的增值服务。"
        },
        {
            "title": "投资协议中的优先认购权条款适用于目标企业（　　）。",
            "questions": "I．发行新股<br>II．发行可转债<br>III．其他股东对外出售股权",
            "question": "A．I、II\nB．I、II、III\nC．I、III\nD．III",
            "answer": "A",
            "explain": ""
        }, {
            "title": "关于企业上市后股权转让退出，以下表述正确的是（　　）。",
            "questions": "I．协议转让根据情形的不同可以分为协议收购、对价偿还、股份回购等<br>II．要约收购包含全面要约和部分要约两种情况<br>III．大宗交易会对竞价交易的股票价格形成巨大冲击<br>IV．收购人持有一个上市公司的股份达到该公司已发行股份的30%时，继续增持股份的，应当采取要约方式进行",
            "question": "A．I、II、III\nB．I、II、IV\nC．III、IV\nD．II、III、IV",
            "answer": "B",
            "explain": "大宗交易转让的卖方和买方根据拟转让的股份及其数量，可以就交易价格和数量等要素进行协议议价，卖方容易取得更满意的价格。同时，大宗交易不会对竞价交易的股票价格形成巨大冲击，有利于市场稳定。"
        },
        {
            "title": "基金管理人登记事项的重大变更不包括（　　）。",
            "question": "A．基金管理人变更控股股东\nB．基金管理人变更执行事务合伙人\nC．基金管理人增加注册资本或者认缴资本\nD． 基金管理人变更实际控制人",
            "answer": "C",
            "explain": "基金管理人变更控股股东、实际控制人或者法定代表人（执行事务合伙人）的，属于重大事项变更。"
        },
        {
            "title": "通常，股权投资基金的当事人包括（　　）。",
            "questions": "I．基金投资者<br>II．基金管理人<br>III．基金资产管理机构<br>IV．基金托管人",
            "question": "A．III、IV\nB．I、II、III、IV\nC．II、III\nD．I、II、IV",
            "answer": "D",
            "explain": "基金投资者、基金管理人、基金资产管理机构和基金托管人是股权投资基金的主要当事人。"
        },
        {
            "title": "关于创投基金与并购基金的区别，以下表述错误的是（　　）。",
            "question": "A．创投基金采取参股投资，并购基金采取控股投资\nB．创投基金投后重点是增值服务，并购基金投后重点是企业整合\nC．创投基金只投资早期企业，并购基金只投资成熟企业\nD． 创投基金通常不使用杠杆，并购基金通常使用杠杆",
            "answer": "C",
            "explain": "创业投资基金，是指主要投资于处于各个创业阶段的未上市成长性企业的股权投资基金。"
        },
        {
            "title": "关于业务尽职调查的内容，以下表述错误的是（　　）。",
            "question": "A．调查企业的风险状况，包括政策、竞争、财务及管理等方面\nB．调查企业基本情况，包括企业工商登记资料和历史沿革\nC．调查企业的发展战略，包括企业经营理念和模式\nD． 调查企业财务业绩情况，包括历史业绩和未来财务状况预测",
            "answer": "D",
            "explain": "业务尽职调查的内容不包括调查企业财务业绩情况，包括历史业绩和未来财务状况预测。"
        },
        {
            "title": "关于创业投资基金与目标公司签署的投资协议，以下表述正确的是（　　）。",
            "question": "A．创业投资基金主要以获取控制权为目的对目标公司进行投资\nB．创业投资基金主要以增资方式对目标公司进行投资\nC．创业投资基金主要以购买存量股权的方式对目标公司进行投资\nD． 创业投资基金主要以获取固定收益回报为目的对目标公司进行投资",
            "answer": "B",
            "explain": "创业投资基金，是指主要投资于处于各个创业阶段的未上市成长性企业的股权投资基金。"
        },
        {
            "title": "关于信息披露报告的表述，以下表述错误的是（　　）。",
            "question": "A．股权投资基金管理人应保证信息披露报告披露的信息不存在任何虚假记载、误导性陈述或重大遗漏\nB．已在私募基金信息披露备份平台备份的报告可供基金管理人自行下载\nC．股权基金管理人应当按照规定通过中国证券投资基金业协会指定的私募基金信息披露备份平台进行信息披露文件备份\nD． 在私募基金信息披露备份平台备份的信息披露报告，可供社会公众和基金投资者公开查询",
            "answer": "D",
            "explain": "私募基金信息不能供投资者公开查询。"
        }, {
            "title": "基金服务机构在破产或者清算时，以下表述正确的是（　　）。",
            "questions": "I．基金服务机构自有财产属于破产或清算财产<br>II．基金服务业务所涉及的基金财产和投资者财产不属于破产或清算财产<br>III．基金服务业务所涉及的基金财产和投资者财产归属于基金服务机构的自有财产<br>IV．基金服务机构未将基金财产和投资者财产进行分账管理，该部分资产视同清算财产",
            "question": "A．I、II、III、IV\nB．II、III、IV\nC．I、III、IV\nD．I、II",
            "answer": "D",
            "explain": ""
        },
        {
            "title": "关于股权投资基金的初步尽职调查与正式尽职调查，以下表述正确的是（　　）。",
            "question": "A．初步尽调会聘请外部机构参与完成；正式尽调会由内部投资管理小组完成\nB．初步尽调后，需要提交投资建议书；正式尽调后，由外聘机构提交项目尽调报告\nC．初步尽调是对项目进行价值判断，以便立项，正式尽调是对项目进行风险判断，以便估值\nD． 正式尽调是对项目进行价值判断，以便立项，正式尽调是对项目进行风险判断，以便估值",
            "answer": "C",
            "explain": "初步尽职调查的核心是对拟投资项目进行价值判断，并非详尽调查或投资风险评估。正式尽调是对项目进行风险判断，以便估值。"
        },
        {
            "title": "关于创业投资基金对中小微企业所提供的融资服务，以下表述错误的是（　　）。",
            "question": "A．创业投资基金是按企业发展阶段开展分阶段投资，且不会要求被投资企业提供担保措施\nB．创业投资基金通过丰富的投后管理手段，提高所投资企业的创业成功概率\nC．创业投资基金尝试多种机制来获取项目真实信息，缓和投资者获取企业真实信息难度和成本均较高的情况\nD． 创业投资基金采取明股实债的创新方式，实现风险和期望收益的均衡匹配",
            "answer": "D",
            "explain": "创业投资基金主要采取股权投资的方式，通过创新的动态估值方法，可以实现风险和期望收益的均衡匹配。"
        },
        {
            "title": "随售权作为一项股东权利，在股权交易发生时行使的主体通常是（　　）。",
            "question": "A．公司的创始股东\nB．公司的董监高股东\nC．本轮股权交易时的创始股东和董监高股东外的存量股东\nD． 本轮股权交易时的新进股东",
            "answer": "C",
            "explain": "随售权又称共同出售权，是指目标公司的其他股东对外出售股权时，股权投资基金有权以其持股比例为基础，以同等条件参与该出售交易。"
        },
        {
            "title": "关于企业境外上市，以下表述错误的是（　　）。",
            "question": "A．我国企业选择境外直接上市，需要向中国证监会提出申请\nB．境外上市一般包括策划上市方案、准备相关文件、上市申报和公开发行及交易四个步骤\nC．境外上市分为境外直接上市和境外间接上市两种方式\nD． 境外上市外资股包括H股、B股、N股和S股等",
            "answer": "D",
            "explain": ""
        },
        {
            "title": "某股权投资基金A拟向合格投资者募集四亿元资金投资于B公司，B公司管理层预期投资当年的净利润不低于1.5亿元，B公司的企业所得税为25%，利息每年2000万元，拟采用相对估值法对B公司进行估值。若采用市盈率的倍数估值法，按照10倍市盈率对B公司进行估值，价值为（　　）。",
            "question": "A．14.8亿\nB．17亿\nC．13亿\nD． 15亿",
            "answer": "D",
            "explain": "股权价值=净利润x市盈率倍数=1.5亿x10=15亿。"
        },
        {
            "title": "若已登记私募基金管理人涉嫌违法违规，中国证券投资基金业协会可对其采取的措施不包括（　　）。",
            "question": "A．公开谴责该公司不当行为\nB．对主要负责人谈话提醒、书面警示、要求参加强制培训\nC．暂停会员资格\nD． 出具警示函、责令改正",
            "answer": "D",
            "explain": "出具警示函、责令改正属于证监会行政监管措施。"
        }, {
            "title": "对于股权投资基金，基金投资者的受托人包括（　　）。",
            "questions": "I．基金管理人<br>II．基金托管人<br>III．基金销售机构<br>IV．基金份额登记机构",
            "question": "A．I、II、III\nB．I、II\nC．I、II、III、IV\nD．II、III、IV",
            "answer": "B",
            "explain": ""
        },
        {
            "title": "关于股权投资基金的清算退出流程，以下表述错误的是（　　）。",
            "question": "A．所有投资项目都实现到期退出的，应当安排基金清算\nB．无论是公司型、合伙型、还是信托(契约)型股权投资基金，都应该及时向市场监督管理部门办理注销手续\nC．清算过程中的剩余财产应该先支付税费然后向投资人分配\nD． 基金存续期限届满且公司或全体合伙人决定不再经营的，应当安排清算",
            "answer": "B",
            "explain": "所有投资项目都实现到期退出的，应当安排基金清算；清算过程中的剩余财产应该先支付税费然后向投资人分配；基金存续期限届满且公司或全体合伙人决定不再经营的，应当安排清算。由于信托型基金无须在工商行政管理机关办理工商登记手续，所以在基金清算的时候无需向市场监督管理部门办理注销手续。"
        },
        {
            "title": "王某2008年初向A基金投资了200万元，基金合同约定基金管理费为每年2%，2010年未和2012年末，王某分别收到项目退出回款30万元和70万元，于2012年末王某持有的基金份额的估值为300万元，2012年末于某投资A基金的已分配收益倍数(DPI)为（　　）。",
            "question": "A．0.5\nB．0.44\nC．2\nD．1.96",
            "answer": "A",
            "explain": "已分配收益倍数是指截至某一特定时点，投资者已从基金获得的分配金额总和与投资者已向基金缴款金额总和的比率，体现了投资者现金的回收情况。投资者已获分配金额=30万+70万=100万。投资者缴款金额为200万，则已分配倍数=100万÷200万=0.5。"
        },
        {
            "title": "股权投资基金投资项目中清算退出方式包括（　　）。",
            "questions": "I．解散清算<br>II．破产清算<br>III．清盘清算",
            "question": "A．II、III\nB．I、II\nC．I、III\nD．I、II、III",
            "answer": "B",
            "explain": "股权投资基金投资项目中清算退出方式包括解散清算、破产清算、清盘清算。"
        },
        {
            "title": "关于我国股权投资基金投资者的主要类型，以下表述正确的是（　　）。",
            "question": "A．政府引导基金是由专业基金管理人设立、政府作为投资人参与的创业投资基金，直接投资于政府引导支持的创业\nB．我国证券公司目前主要通过设立投资管理子公司的形式进入股权投资基金管理行业\nC．工商企业是目前我国股权投资基金主要的投资资金来源，其中包括国有企业、民营企业等，暂不包括外国企业\nD． 保险公司的投资资金受到保单赎回、客户退保等波动因素影响，不适合作为长期投资参与股权投资基金",
            "answer": "B",
            "explain": ""
        },
        {
            "title": "以下投资行为属于天使投资的是（　　）。",
            "question": "A．某互联网公司老板投资某创新环保企业\nB．某互联网公司老板投资某股权投资基金，并通过该股权投资基金投资某创新环保企业\nC．某互联网公司投资某创新环保企业\nD． 某互联网公司老板投资其名下公司的附属企业",
            "answer": "A",
            "explain": "天使投资是指降被投资企业职员及家庭关系成员和直系亲属以外的个人以其自有资金直接开展的创业投资活动，属于非组织化创业投资范畴，故“某互联网公司老板投资某创新环保企业”属于天使投资。"
        }
    ]
}


// WEBPACK FOOTER //
// ./src/utils/fund/2024/11/smgq-3.js